import React, { Component } from 'react';
class ClientGeneralInformation extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="full_name" placeholder="Full Name / Business Name"/>
                                        <label for="name">Full Name / Business Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="user_type" name="form_type">
                                        <option value="">Client Type</option>
                                        <option value="Individual">Individual</option>
                                        <option value="Company">Company</option>
                                        <option value="Trust">Trust</option>
                                        <option value="Partnership">Partnership</option>
                                        <option value="HUF">HUF</option>
                                        <option value="Government Entity">Government Entity</option>
                                    </select>
                                    <label for="name">Client Type</label>
                                    </div>
                                </div>



                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="father_name" placeholder="Father's Name / Mother's Name"/>
                                        <label for="name">Father&#39;s / Spouse&#39;s / Authorized Person’s Name</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="bate_of_birth" placeholder="Date of Birth"/>
                                        <label for="name">Date of Birth / Incorporation Date</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="user_type" name="form_type">
                                        <option value="">Gender</option>
                                        <option value="Female">Female</option>
                                        <option value="Male">Male</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Gender</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="user_type" name="form_type">
                                        <option value="">Nationality</option>
                                        <option value="Indian,">Indian,</option>
                                        <option value="NRI">NRI</option>
                                        <option value="OCI">OCI</option>
                                        <option value="Foreign Citizen">Foreign Citizen</option>
                                    </select>
                                    <label for="name">Nationality &amp; Residency Status</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="user_type" name="form_type">
                                        <option value="">Marital Status</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Widowed">Widowed</option>
                                        <option value="Divorced">Divorced</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Marital Status</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="emergency_contact" placeholder="Emergency Contact Details"/>
                                        <label for="name">Email ID</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="spouse_name" placeholder="Spouse's Name"/>
                                        <label for="name">Mobile Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="nationality" placeholder="Nationality"/>
                                        <label for="name">Alternate Contact Number</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="user_type" name="form_type">
                                        <option value="">Mode of Engagement</option>
                                        <option value="Walk-in">Walk-in</option>
                                        <option value="Online Inquiry">Online Inquiry</option>
                                        <option value="Retained Client">Retained Client</option>
                                        <option value="Reverse Solicitation">Reverse Solicitation</option>
                                    </select>
                                    <label for="name">Mode of Engagement</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="nationality" placeholder="Nationality"/>
                                        <label for="name">Communication Address</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                  <div className="col-md-2 p-0">
                                      <button className="btn btn-primary w-100 py-3" type="button">Submit</button>
                                  </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ClientGeneralInformation;
